import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Profil',
  lead: 'Dein Name, deine Sprache und deine Datenschutzeinstellungen.',
  pendingBadge: '{{count}} offene Zustimmungsanfrage',
  nav: {
    label: 'Profilmenü',
    profile: 'Profil',
    consents: 'Zustimmungen',
    preferences: 'Einstellungen',
    subscription: 'Abonnement',
  },
  preferredLanguage: 'Bevorzugte Sprache',
  preferredLanguageOptional: 'Bevorzugte Sprache (optional)',
  preferredLanguageUnset: 'Nicht festgelegt',
  timezoneUnset: 'Standard der Bereitstellung',
  saved: 'Gespeichert.',
  save: 'Speichern',
  privateFieldsHint:
    'Diese vier sind privat — nur du kannst sie sehen oder ändern, unabhängig davon, wer sonst deine Daten sehen darf.',
  details: {
    title: 'Angaben',
    rolesTitle: 'Rollen',
  },
  regionAndTimezone: {
    title: 'Region & Zeitzone',
  },
  fields: {
    name: 'Name',
    email: 'E-Mail',
    nickname: 'Spitzname',
    region: 'Region',
    regionUnset: 'Nicht festgelegt',
    regionHint: 'Das Land, für das deine Statistiken/Berichte lokalisiert werden.',
    timezone: 'Zeitzone für Statistiken',
    timezoneHint: 'Der Kalender, nach dem deine Statistiktage abgegrenzt werden.',
    gender: 'Geschlecht',
    birthdate: 'Geburtsdatum',
    height: 'Größe (cm)',
    weight: 'Gewicht (kg)',
  },
};
